<script>
  import { router } from '@inertiajs/svelte'
  
  let { sid = '', errors = {} } = $props();
  
  let password = $state('');
  let passwordConfirmation = $state('');
  
  function submit(event) {
    event.preventDefault();
    router.patch('/identity/password_reset', {
      sid,
      password,
      password_confirmation: passwordConfirmation
    });
  }
  
  // Helper functions for errors
  function hasErrors() {
    return Object.keys(errors).length > 0;
  }
  
  function countErrors() {
    let count = 0;
    for (const field in errors) {
      if (Array.isArray(errors[field])) {
        count += errors[field].length;
      }
    }
    return count;
  }
  
  function getErrorMessages() {
    const messages = [];
    for (const field in errors) {
      if (Array.isArray(errors[field])) {
        errors[field].forEach(message => {
          messages.push(`${field} ${message}`);
        });
      }
    }
    return messages;
  }
</script>

<div class="password-reset-container">
  <h1>Reset your password</h1>
  
  {#if hasErrors()}
    <div class="error-summary">
      <h2>{countErrors()} {countErrors() === 1 ? 'error' : 'errors'} prohibited this user from being saved:</h2>
      
      <ul>
        {#each getErrorMessages() as message}
          <li>{message}</li>
        {/each}
      </ul>
    </div>
  {/if}
  
  <form onsubmit={submit}>
    <input type="hidden" name="sid" value={sid} />
    
    <div class="form-group">
      <label for="password" class="form-label">New password</label>
      <!-- svelte-ignore a11y_autofocus -->
      <input 
        id="password" 
        type="password" 
        bind:value={password} 
        required 
        autofocus 
        autocomplete="new-password"
        class={errors.password ? 'form-input error' : 'form-input'}
      />
      <div class="form-hint">12 characters minimum.</div>
      {#if errors.password}
        <div class="error-message">{errors.password.join(', ')}</div>
      {/if}
    </div>
    
    <div class="form-group">
      <label for="password_confirmation" class="form-label">Confirm new password</label>
      <input 
        id="password_confirmation" 
        type="password" 
        bind:value={passwordConfirmation} 
        required 
        autocomplete="new-password"
        class={errors.password_confirmation ? 'form-input error' : 'form-input'}
      />
      {#if errors.password_confirmation}
        <div class="error-message">{errors.password_confirmation.join(', ')}</div>
      {/if}
    </div>
    
    <div class="form-actions">
      <button type="submit" class="save-button">Save changes</button>
    </div>
  </form>
</div>

<style>
  .password-reset-container {
    max-width: 500px;
    margin: 0 auto;
    padding: 2rem 1rem;
  }
  
  h1 {
    font-size: 1.875rem;
    font-weight: 600;
    margin-bottom: 1.5rem;
  }
  
  .error-summary {
    background-color: #fee2e2;
    border: 1px solid #ef4444;
    border-radius: 0.375rem;
    padding: 1rem;
    margin-bottom: 1.5rem;
  }
  
  .error-summary h2 {
    color: #b91c1c;
    font-size: 1rem;
    font-weight: 600;
    margin-bottom: 0.5rem;
  }
  
  .error-summary ul {
    margin: 0;
    padding-left: 1.25rem;
    color: #b91c1c;
  }
  
  .form-group {
    margin-bottom: 1.25rem;
  }
  
  .form-label {
    display: block;
    font-weight: 500;
    margin-bottom: 0.375rem;
  }
  
  .form-input {
    width: 100%;
    padding: 0.625rem;
    border: 1px solid #d1d5db;
    border-radius: 0.375rem;
    font-size: 1rem;
  }
  
  .form-input.error {
    border-color: #ef4444;
    background-color: #fef2f2;
  }
  
  .form-hint {
    font-size: 0.875rem;
    color: #6b7280;
    margin-top: 0.25rem;
  }
  
  .error-message {
    color: #ef4444;
    font-size: 0.875rem;
    margin-top: 0.25rem;
  }
  
  .form-actions {
    margin-top: 1.5rem;
  }
  
  .save-button {
    background-color: #047857;
    color: white;
    border: none;
    padding: 0.625rem 1.25rem;
    border-radius: 0.375rem;
    font-weight: 500;
    font-size: 1rem;
    cursor: pointer;
    width: 100%;
  }
  
  .save-button:hover {
    background-color: #065f46;
  }
</style>